import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { PageHero } from '../components/interior/PageElements';

export default function NotFoundPage() {
  useEffect(() => { document.title = 'Page Not Found | Longhorn Milling'; }, []);
  return <PageHero eyebrow="404 / PAGE NOT FOUND" title="Let’s get you back on track." description="This page isn’t available. Return to the homepage or choose a section from the navigation." breadcrumbs={[{ label: 'Page Not Found' }]}><Link to="/" className="site-button" data-testid="not-found-home"><ArrowLeft size={17} aria-hidden="true" />Back to Home</Link></PageHero>;
}